

















// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';

import { API_MOTION_SEARCH, API_CATEGORY_QUERY } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      categories: [],
    };
  },
  methods: {
    async load() {
      const response = await ApiRequest.Get(API_CATEGORY_QUERY);
      this.$data.categories = response;
    },
  },
  mounted() {
    this.load();
  },
});
